import { render, staticRenderFns } from "./PoliList.vue?vue&type=template&id=5bf031b4&scoped=true"
import script from "./PoliList.vue?vue&type=script&lang=js"
export * from "./PoliList.vue?vue&type=script&lang=js"
import style0 from "./PoliList.vue?vue&type=style&index=0&id=5bf031b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf031b4",
  null
  
)

export default component.exports